export const fixedValues = {
  subscriptionPlans: {
    MONTHLY: { title: "Monthly", price: "6.99", interval: "month" },
    ANNUAL: { title: "Annual", price: "74.49", interval: "year" },
  },
  subscriptionUpdateActions: { ADD: "add", REMOVE: "remove" },
  validRoles: ["owner", "admin", "teamLead"],
  menuOptions: ["Teams", "Subscription", "Features"],
  subscriptionMethods: { MOBILE: "mobile", WEB: "web", MANUAL: "manual" },
  mobileProductPlans: {
    "clubbie.plus.monthly": {
      title: "Monthly",
      price: "6.99",
      plan: "Monthly / £6.99",
    },
    "clubbie.plus.annual": {
      title: "Annual",
      price: "74.49",
      plan: "Annual / £74.49",
    },
  },
  features: [
    {
      name: "Member registration",
      description: "Register members and manage their profiles efficiently.",
      plusFeature: false,
    },
    {
      name: "Event scheduling & RSVPs",
      description: "Plan and schedule events with RSVP tracking.",
      plusFeature: false,
    },
    {
      name: "Messaging & group chats",
      description: "Communicate with team members in real-time.",
      plusFeature: false,
    },
    {
      name: "Team payments",
      description:
        "Simplify the collection and tracking of recurring and one-off payments for your team.",
      plusFeature: false,
    },
    {
      name: "Live Scores",
      description: "Track scores live and send real-time updates to members.",
      plusFeature: false,
    },
    {
      name: "Basic team stats",
      description: "Monitor basic team performance statistics.",
      plusFeature: false,
    },
    {
      name: "Lineups & formations",
      description: "Customise formations and manage your matchday lineup.",
      plusFeature: true,
    },
    {
      name: "Matchday graphics",
      description: "Generate stunning matchday graphics effortlessly.",
      plusFeature: true,
    },
    {
      name: "Advanced team stats",
      description: "Access detailed analytics and team performance insights.",
      plusFeature: true,
    },
    {
      name: "5% Clubbie teamwear discount",
      description: "Enjoy exclusive discounts on Clubbie teamwear.",
      plusFeature: true,
    },
  ],
  subMsgs: {
    mobileSubMsg: (
      <>
        *The subscription for this team is managed through mobile. Reach out to{" "}
        <span className="highlight">hello@clubbie.com</span> if you have any
        questions or need support.
      </>
    ),

    customSubMsg: (
      <>
        *The subscription for this team was created manually. Reach out to{" "}
        <span className="highlight">hello@clubbie.com</span> if you have any
        questions or need support.
      </>
    ),
  },

  paymentStatuses: {
    REQUIRES_ACTION: "requires_action",
  },
  pagination: {
    PAGE: 1,
    LIMIT: 10,
  },
  registarationType: {
    REGISTERED: "Registered",
    NOT_REGISTERED: "Not Registered",
  },
  tournamentTypes: {
    LEAGUE: "League",
    CUP: "Cup",
    GROUP: "Tournament - Group Stage + Knockout",
    KNOCKOUT: "Tournament - Knockout-only",
  },
  durationTypes: {
    SINGEL_DAY_TOURNAMENT: "SINGLE_DAY",
    LONG_TERM_TOURNAMENT: "LONG_TERM",
    SINGEL_DAY_TOURNAMENT_LABEL: "Single Day Tournament",
    LONG_TERM_TOURNAMENT_LABEL: "Long Term Tournament",
  },
  defaultTournamentDetails: {
    division: {
      name: "Default Division",
      season:
        { name: "Default Season" },
    },
  },
  sportTypes: {
    FOOTBALL: "football",
    RUGBY: "rugby",
    TOUCH_RUGBY: "touchRugby"
  },
  responseCodes: {
    UNAUTHORIZED: 401,
  },
  teamStatus: {
    PENDING: "PENDING",
    ACCEPTED: "ACCEPTED",
    REJECTED: "REJECTED",
  },
  registrationFeeStatus: {
    PENDING: "PENDING",
    ACCEPTED: "ACCEPTED",
    REJECTED: "REJECTED",
  },
  eventTypes: {
    MATCH: "match",
    TRAINING: "training",
    SOCIAL: "social",
  },
  IMAGE_PURPOSE: {
    TOURNAMENT_IMG: "tournamentImg",
    USER_IMG: "userImg",
  },
  userRoles: {
    ORGANISATION_ADMIN: "organisationAdmin",
    TOURNAMENT_ADMIN: "tournamentAdmin",
    DIVISION_ADMIN: "divisionAdmin",
    REFEREE: "referee",
  },

  resultTypes: {
    WIN: 'W',
    DRAW: 'D',
    LOSS: 'L',
  },

  sortTeamsOptions: {
    WINS: 'wins',
    DRAWS: 'draws',
    LOSSES: 'losses',
    GOALS_SCORED: 'goalsScored',
    CLEAN_SHEETS: 'cleanSheets',
    PENALTIES: 'penalties',
    YELLOW_CARDS: 'yellowCards',
    RED_CARDS: 'redCards',
    CLUBBIE_RANKING: 'clubbieRanking',
    WIN_PERCENTAGE: 'winPercentage',
    GOALS_PER_GAME: 'goalsPerGame',
    CLEAN_SHEETS_PER_GAME: 'cleanSheetsPerGame'
  },

  sortRugbyTeamsOptions: {
    WINS: 'wins',
    DRAWS: 'draws',
    LOSSES: 'losses',
    POINTS_SCORED: 'points',
    TRIES: 'tries',
    PENALTIES: 'penalties',
    CONVERSIONS: 'conversions',
    DROP_GOALS: 'dropGoals',
    POINTS_DIFFERENCE: 'pointsDifference',
    KICKS: 'kicks',
    YELLOW_CARDS: 'yellowCards',
    RED_CARDS: 'redCards',
    WIN_PERCENTAGE: 'winPercentage',
    POINTS_PER_GAME: 'pointsPerGame',
    TRIES_PER_GAME: 'triesPerGame'
  },

  matchDetailTypes: {
    // football
    GOAL: 'goal',
    ASSIST: 'assist',
    RED_CARD: 'red_card',
    YELLOW_CARD: 'yellow_card',
    // for naming through matchDetailType type
    GOALS: 'goals',
    ASSISTS: 'assists',
    RED_CARDS: 'redCards',
    YELLOW_CARDS: 'yellowCards',
    // korfball
    LONG_GOALS: 'longGoals',
    SHORT_GOAL: 'shortGoals',
    MID_GOALS: 'midGoals',
    RUNNER_GOALS: 'runnerGoals',
    FREE_PASS_GOAL: 'freePassGoals',
    PENALTY_GOALS: 'penaltyGoals',
    REBOUNDS: 'rebounds',
    OWN_GOALS: 'ownGoals',
    SUBSTITUTIONS: 'substitutions',
    SUBBED_ON: 'subbedOn',
    SUBBED_OFF: 'subbedOff',
    SECOND_YELLOW_CARDS: 'secondYellowCards',
    COMMENT: 'comment',
    // cricket
    FIFTY_CRICKET: 'fiftyCricket',
    HUNDRED_CRICKET: 'hundredCricket',
    WICKETS: 'wickets',
    CATCHES: 'catches',
    RUNOUTS: 'runOuts',
    // universal stats
    GAME_WON: 'gameWon',
    GAME_LOST: 'gameLost',
    HIGH_FINIS: 'highFinish',
    _9_DART_LEG: '9DartLeg',
    TRY: 'try',
    CONVERSION: 'conversion',
    PENALTY: 'penalty',
    DROP_GOAL: 'dropGoal',
    FRAME_WON: 'frameWon',
    FRAME_LOST: 'frameLost',
    FRAME_SCORE: 'frameScore',
    _100_BREAK: '_100PlusBreak',
    _50_BREAK: '_50PlusBreak',
    BREAK_FINISH: 'breakFinish',
    REVERSE_FINISH: 'reverseFinish',
    RACE_WON: 'raceWon',
    RACE_2ND_PLACE: 'race2ndPlace',
    RACE_3RD_PLACE: 'race3rdPlace',
    RACE_TIME: 'raceTime',
    _1_POINTER: '_1Pointer',
    _2_POINTER: '_2Pointer',
    _3_POINTER: '_3Pointer',
    KNOCKDOWN: 'knockdown',
    KNOCKOUT: 'knockout',
    KNOCKOUT_W: 'knockoutW',
    KNOCKOUT_L: 'knockoutL',
    STOPPAGE: 'stoppage',
    STOPPAGE_W: 'stoppageW',
    STOPPAGE_L: 'stoppageL',
    UNANIMOUS_DECISION_W: 'unanimousDecisionW',
    UNANIMOUS_DECISION_L: 'unanimousDecisionL',
    SPLIT_DECISION_W: 'splitDecisionW',
    SPLIT_DECISION_L: 'splitDecisionL',
    SCORE: 'score',
    POINTS: 'points',
    TIME: 'time',
    CUSTOM_STAT_TYPE: 'customStatType',
    FOUL: 'foul',
  }

};